import React from "react";
import { useSEO } from "../hooks/useSEO";

const EDITIONS = [
  { year: "2026", label: "MMXXVI", status: "current", description: "Première édition — en cours" },
];

export default function Archives() {
  useSEO("Archives", "Retrouvez l'histoire du Stand d'Or, édition par édition.");

  return (
    <div className="pt-[140px] pb-40 max-w-[1300px] mx-auto px-6 lg:px-12">
      <p className="label mb-8" style={{ color: "#C9A961" }}>Le Stand d'Or — Histoire</p>
      <h1
        className="font-serif mb-20"
        style={{ fontSize: "clamp(56px, 9vw, 140px)", lineHeight: 0.9, letterSpacing: "-0.025em", color: "#F8F6F0" }}
      >
        Archives.
      </h1>

      <div className="hairline mb-20" />

      <ul>
        {EDITIONS.map((ed) => (
          <li key={ed.year} className="py-12" style={{ borderBottom: "1px solid #1c1c1c" }}>
            <div className="flex flex-wrap items-start justify-between gap-6">
              <div>
                <p className="label mb-3" style={{ color: "#A1A1AA" }}>{ed.year}</p>
                <p
                  className="font-serif"
                  style={{ fontSize: "clamp(56px, 8vw, 96px)", color: ed.status === "current" ? "#C9A961" : "#F8F6F0", lineHeight: 1, letterSpacing: "-0.02em" }}
                >
                  {ed.label}
                </p>
                <p className="mt-6" style={{ color: "rgba(248,246,240,0.65)", fontSize: 17 }}>{ed.description}</p>
              </div>
              {ed.status === "current" && (
                <span className="label" style={{ color: "#C9A961", border: "1px solid #C9A961", padding: "6px 14px", flexShrink: 0, marginTop: 4 }}>En cours</span>
              )}
            </div>
          </li>
        ))}
        <li className="py-12" style={{ borderBottom: "1px solid #1c1c1c" }}>
          <p className="label" style={{ color: "#A1A1AA" }}>Prochaines éditions — à venir</p>
        </li>
      </ul>

      <p className="mt-20" style={{ color: "rgba(248,246,240,0.4)", fontSize: 14, fontStyle: "italic" }}>
        Les archives des éditions passées seront accessibles ici après chaque cérémonie.
      </p>
    </div>
  );
}
